import React from "react";
import { Product } from "../../utils/types";
import ProductCard from "../shared/productCard";

type AlsoProductsProps = {
    products: Product[];
};

const AlsoProducts: React.FC<AlsoProductsProps> = ({ products }) => {

    return (
        <div className="overflow-hidden">
            <div className={`${products.length > 3 ? 'lg:justify-between' : 'lg:justify-center'} flex justify-center w-full overflow-x-auto gap-x-[2%] gap-y-2 md:gap-y-4 lg:gap-x-[3.3%] lg:gap-y-10 pb-4 flex-wrap`}>
                {products.length > 0 && (
                    products.map((p: Product, idx) => {
                        return (
                            <div key={idx} className="group xs:flex-[0_0_49%] lg:flex-[0_0_22.5%] xs:max-w-[49%] lg:max-w-[22.5%]">
                                <ProductCard
                                    className='!border-0'
                                    product={p}
                                />
                            </div>
                        );
                    })
                )
                }
            </div>
        </div>
    );
};

type ArrowProps = {
    onClick: () => void;
    isDisabled?: boolean;
    className?: string;
    isFullscreen?: boolean;
};

export const ArrowLeft: React.FC<ArrowProps> = ({
    onClick,
    className = "",
    isDisabled = false,
    isFullscreen = false,
}) => {
    return (
        <button
            aria-label="Arrow left"
            disabled={isDisabled}
            className={`${className} ${isDisabled ? 'opacity-50' : ''} transition-all ease-in-out duration-300 fill-stroke-color hover:fill-dark-blu`}
            onClick={onClick}
        >
            {isFullscreen && (
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M11.28 15.7l-1.34 1.37L5 12l4.94-5.07 1.34 1.38-2.68 2.72H19v1.94H8.6z"></path></svg>
            ) || (
                    <svg className="rotate-[90deg]" fill="#000" width="38px" height="38px" viewBox="0 0 256 256" id="Flat" xmlns="http://www.w3.org/2000/svg">
                        <path d="M128,28A100,100,0,1,0,228,128,100.11332,100.11332,0,0,0,128,28Zm0,192a92,92,0,1,1,92-92A92.10416,92.10416,0,0,1,128,220Zm42.82812-94.82813a3.99854,3.99854,0,0,1,0,5.65625l-33.94091,33.94141a3.99992,3.99992,0,0,1-5.65674-5.65674L158.34326,132H88a4,4,0,0,1,0-8h70.34326L131.23047,96.88721a3.99992,3.99992,0,0,1,5.65674-5.65674Z" />
                    </svg>
                )}

        </button>
    );
};

export const ArrowRight: React.FC<ArrowProps> = ({
    onClick,
    className = "",
    isDisabled = false,
    isFullscreen = false,
}) => {
    return (
        <button
            aria-label="Arrow right"
            disabled={isDisabled}
            className={`${className} ${isDisabled ? 'opacity-50' : ''} transition-all ease-in-out duration-300 fill-stroke-color hover:fill-dark-blu`}
            onClick={onClick}
        >
            {isFullscreen && (
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M15.4 12.97l-2.68 2.72 1.34 1.38L19 12l-4.94-5.07-1.34 1.38 2.68 2.72H5v1.94z"></path></svg>
            ) || (
                    <svg className="rotate-90" fill="#000" width="38px" height="38px" viewBox="0 0 256 256" id="Flat" xmlns="http://www.w3.org/2000/svg">
                        <path d="M128,28A100,100,0,1,0,228,128,100.11332,100.11332,0,0,0,128,28Zm0,192a92,92,0,1,1,92-92A92.10416,92.10416,0,0,1,128,220Zm42.82812-94.82813a3.99854,3.99854,0,0,1,0,5.65625l-33.94091,33.94141a3.99992,3.99992,0,0,1-5.65674-5.65674L158.34326,132H88a4,4,0,0,1,0-8h70.34326L131.23047,96.88721a3.99992,3.99992,0,0,1,5.65674-5.65674Z" />
                    </svg>
                )}

        </button>
    );
};

export const ArrowSmall: React.FC<ArrowProps> = ({
    onClick,
    className = "",
    isDisabled = false,
}) => {
    return (
        <button
            aria-label="Arrow right"
            disabled={isDisabled}
            className={`${className} ${isDisabled ? 'opacity-50' : ''} transition-all ease-in-out duration-300 fill-stroke-color hover:fill-dark-blu`}
            onClick={onClick}
        >
            <svg fill="#000000" width="20px" height="20px" viewBox="-2 -2 24 24" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMinYMin"><path d='M11.828 10l-3.535 3.536a1 1 0 0 0 1.414 1.414l4.243-4.243a1 1 0 0 0 0-1.414L9.707 5.05a1 1 0 0 0-1.414 1.414L11.828 10zM10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10-4.477 10-10 10z' /></svg>
        </button>
    );
};

export default AlsoProducts;
